"use strict";

var ipRegex = require("ip-regex");

var defaultOpts = {
  exact: false
};
var v4str = "".concat(ipRegex.v4().source, "\\/(3[0-2]|[12]?[0-9])");
var v6str = "".concat(ipRegex.v6().source, "\\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])"); // can not precompile the non-exact regexes because global flag makes the regex object stateful
// which would require the user to reset .lastIndex on subsequent calls

var v4exact = new RegExp("^".concat(v4str, "$"));
var v6exact = new RegExp("^".concat(v6str, "$"));
var v46exact = new RegExp("(?:^".concat(v4str, "$)|(?:^").concat(v6str, "$)"));

module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts,
      exact = _ref.exact;

  return exact ? v46exact : new RegExp("(?:".concat(v4str, ")|(?:").concat(v6str, ")"), "g");
};

module.exports.v4 = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts,
      exact = _ref2.exact;

  return exact ? v4exact : new RegExp(v4str, "g");
};

module.exports.v6 = function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts,
      exact = _ref3.exact;

  return exact ? v6exact : new RegExp(v6str, "g");
};